import styles from './Shell.module.css';

export const BrandMark = ({ name }: { name: string }) => (
  <span className={styles['brandMark']} aria-hidden="true">
    {name.charAt(0)}
  </span>
);
